import React from 'react';
import Footer from '../components/Footer';

export default function TermsOfUse() {
  return (
    <div>
      <div className="bg-gray-100 min-h-screen py-20 px-4 md:px-6">
        <div className="max-w-3xl mx-auto bg-white rounded-md p-6 md:p-8 text-gray-800">
          <h1 className="text-3xl font-bold mb-4 text-teal-600 border-b pb-2">Terms of Use</h1>

          <p className="mb-6 text-base leading-relaxed">
            By accessing <span className="font-semibold text-teal-600">justoffplan.ai</span>, you agree to comply with and be bound by these terms of use.
            If you do not agree, please do not use our site.
          </p>

          <div className="space-y-8">
            <section>
              <h2 className="text-xl font-semibold text-teal-600 mb-2">Use of Site</h2>
              <p className="text-base text-gray-700">
                Our content is provided for general information only. While we aim to keep it accurate and up to date, we do not guarantee its completeness or reliability.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-teal-600 mb-2">Intellectual Property</h2>
              <p className="text-base text-gray-700">
                All content on this website is the property of <span className="font-semibold text-teal-600">justoffplan.ai</span>. You may not reuse, copy, or reproduce any part of it without written permission.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-teal-600 mb-2">Limitation of Liability</h2>
              <p className="text-base text-gray-700">
                We are not responsible for any direct, indirect, or incidental losses or damages arising from the use of content, services, or external links on this site.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-teal-600 mb-2">Changes to Terms</h2>
              <p className="text-base text-gray-700">
                We reserve the right to change or update these terms at any time. Continued use of the website indicates your acceptance of the updated terms.
              </p>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
